import { cn } from "utils/cn";

export enum BUTTON_TYPES {
  DEVICE = "device",
  FILTER = "filter",
  CONFIRM = "confirm",
  AUTH = "auth",
  CANCEL = "cancel",
  HOME = "home",
  SPACE_AUTH = "space_auth",
}

const DEFAULT_GAME_BUTTON =
  "text-white p-2 justify-center rounded-md hover:bg-opacity-80";

export const BUTTON_STYLES: Record<BUTTON_TYPES, string> = {
  [BUTTON_TYPES.DEVICE]:
    "text-left text-white pl-2 py-2 hover:bg-faux-ultramarine-blue hover:bg-opacity-40",
  [BUTTON_TYPES.FILTER]:
    "flex flex-row items-center w-full h-7 p-3 bg-white text-sm hover:bg-black hover:bg-opacity-10",
  [BUTTON_TYPES.CONFIRM]: `${DEFAULT_GAME_BUTTON} bg-faux-ultramarine-blue w-[130px]`,
  [BUTTON_TYPES.CANCEL]:
    "p-2 justify-center rounded-md hover:bg-opacity-80 bg-dark-gray-blue border border-solid border-faux-ultramarine-blue text-faux-ultramarine-blue w-[130px] hover:border-opacity-80",
  [BUTTON_TYPES.AUTH]: `${DEFAULT_GAME_BUTTON} bg-auth-blue font-semibold`,
  [BUTTON_TYPES.HOME]: `${DEFAULT_GAME_BUTTON} bg-faux-ultramarine-blue w-[400px] mt-16`,
  [BUTTON_TYPES.SPACE_AUTH]: cn(
    "w-[148.15px] h-[35.04px] rounded-[8.76px] font-semibold text-[14px] cursor-pointer transition-colors flex items-center justify-center gap-[4.61px] bg-[#2DE8F4] text-[#09090B] hover:bg-[#2ED2CD]",
    "disabled:[background:linear-gradient(26.34deg,rgba(45,170,133,0.6)_-99.41%,rgba(45,232,244,0.6)_111.98%),linear-gradient(0deg,rgba(0,0,0,0.2),rgba(0,0,0,0.2))]",
    "disabled:[backdrop-filter:blur(96.54596710205078px)]",
  ),
};
